export default {
  computed: {
    queryInItemList() {
      return this.itemList && this.query && !!this.itemList.find((item) => this.isEqualToText(item, this.query));
    },
    queryInItemExcludedList() {
      return (
        this.excludedList && this.query && !!this.excludedList.find((item) => this.isEqualToText(item, this.query))
      );
    },
    unselectedItems() {
      const items = this.itemList || [];
      return this.filterSelectedItems(items);
    },
  },
  data() {
    return {
      query: '',
      scrollEnabled: true,
    };
  },
  watch: {
    query(newVal) {
      this.$emit('query-changed', newVal);
    },
  },
  methods: {
    filterSelectedItems(items) {
      const selectedItems = this.selectedItems || [];
      const result = items.filter((item) => {
        const isInSelected = selectedItems.find((selected) => this.getId(selected) === this.getId(item));
        return !isInSelected;
      });

      return result;
    },
    selectItem(item) {
      if (!this.loading) {
        if (this.getId(item) === undefined && this.getText(item) !== undefined) {
          this.itemFactory(this.getText(item), this.$root).then(this.selectItem);
        } else {
          this.query = '';
          this.$emit('item-selected', item);
        }
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    createItem() {
      const query = this.capitalizeFirstLetter(this.query.trim());

      if (!this.loading && query.length > 0 && this.addNewItem && !this.queryInItemExcludedList) {
        const equalTextSelectedAlready = !!this.selectedItems.find((item) => this.isEqualToText(item, query));
        const itemEqualText = this.itemList.find((item) => this.isEqualToText(item, query));
        if (!equalTextSelectedAlready && !itemEqualText) {
          this.itemFactory(query, this.$root).then(this.selectItem);
        } else if (itemEqualText) {
          this.selectItem(itemEqualText);
        }
      }
    },
    charHandler(event) {
      if (this.addItemOnKeypress && this.addItemOnKeypress === event.key && this.addNewItem) {
        event.preventDefault();
        this.createItem();
      }
    },
    disableScroll(previousScroll = false) {
      if (this.scrollEnabled) {
        if (!previousScroll) {
          document.body.classList.add('scroll-blocked');
          document.body.style.removeProperty('overflow');
        }
        document.addEventListener('wheel', this.preventScroll, { passive: false });
        document.addEventListener('touchmove', this.preventScroll, { passive: false });
        this.scrollEnabled = false;
      }
    },
    enableScroll(previousScroll = false) {
      if (!this.scrollEnabled) {
        if (!previousScroll) {
          document.body.classList.remove('scroll-blocked');
        }
        document.removeEventListener('wheel', this.preventScroll, { passive: false });
        document.removeEventListener('touchmove', this.preventScroll, { passive: false });
        this.scrollEnabled = true;
      }
    },
    preventScroll(event) {
      event.preventDefault();
    },
    formatText(item) {
      if (this.query) {
        return this.getText(item).replace(new RegExp('(' + this.query + ')', 'i'), '<b>$1</b>');
      }
      return this.getText(item);
    },
    getText(item) {
      return this.textAttribute && item[this.textAttribute] ? item[this.textAttribute] : item.text;
    },
    getId(item) {
      return this.idAttribute ? item[this.idAttribute] : item;
    },
    isEqualToText(item, text) {
      return this.getText(item).toLowerCase().trim() === text.toLowerCase().trim();
    },
  },
};
